import { NavLink } from "react-router-dom";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle
} from "src/components/ui/sheet";
import { navigationConfig } from "./navConfig";
import { NavItems } from "./NavItems";
import { SidebarFooter } from "./SidebarFooter";

interface MobileDrawerProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function MobileDrawer({ open, onOpenChange }: MobileDrawerProps) {
	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent
				side="left"
				className="w-[80vw] max-w-[360px] p-0 flex flex-col"
			>
				<SheetHeader className="border-b border-border px-6 py-4">
					<SheetTitle>
						<NavLink
							to="/admin"
							onClick={() => onOpenChange(false)}
							className="flex items-center"
						>
							<img src="/mee-logo.svg" alt="Mee" className="h-6" />
						</NavLink>
					</SheetTitle>
				</SheetHeader>
				<div className="flex-1 overflow-y-auto px-4 py-4">
					<NavItems
						items={navigationConfig}
						onNavigate={() => onOpenChange(false)}
					/>
				</div>
				<SidebarFooter onNavigate={() => onOpenChange(false)} />
			</SheetContent>
		</Sheet>
	);
}
